module.exports = __webpack_public_path__ + "superhero.41e29ed1.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/profile/superhero.png
// module id = 2496
// module chunks = 0